// Add data-parallax to any element to create the effect.
// 1 is the default scroll speed. You can pass in a negative value to go in the other direction, or increase the number to speed it up.
// e.g data-parallax="3", data-parallax="-1", or even decimal values, data-parallax="0.5"

(() => {
	function init() {
		const parallaxItems = document.querySelectorAll('[data-parallax]');

		// Parallax It!
		function parallax() {
			const scrolled = window.scrollY;

			parallaxItems.forEach((item) => {
				// Config
				const offset = item.dataset.parallax || 1;
				const maxOffset = item.dataset.parallaxMax || 1000;
				const maxMobileOffset = item.dataset.parallaxMobileMax || null;
				const allowMobile = item.dataset.parallaxMobile || 'no';

				// Position vars
				const itemRect = item.getBoundingClientRect();
				const itemTop = itemRect.top + window.scrollY;
				const itemHeight = itemRect.height;

				// Calculate position
				// prettier-ignore
				const pos = itemTop > window.innerHeight
					? ((scrolled - itemTop + itemHeight) / window.innerHeight) * offset * 100 || 0
					: (scrolled / window.innerHeight) * offset * 100 || 0;

				if (window.innerWidth <= 992 && allowMobile === 'no') return;

				if (window.innerWidth <= 992 && maxMobileOffset !== null) {
					if (pos < maxMobileOffset) {
						item.style.setProperty('transform', `translate3d(0, ${-pos}px, 0)`);
					}
				} else if (pos < maxOffset) {
					item.style.setProperty('transform', `translate3d(0, ${-pos}px, 0)`);
				}
			});
		}

		// Passive scroll listener
		window.addEventListener('scroll', parallax, {
			capture: true,
			passive: true
		});

		// Resize listener
		window.addEventListener('resize', () => {
			parallaxItems.forEach((item) => {
				item.setAttribute('style', '');
			});

			parallax();
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});

	$WINDOW.on('page:load-completed', (e) => {
		init();
	});
})();
